const Notification = {
            "options": {},
            "variants": [
                {
                    "id": "Notification_1",
                    "name": "Notification_1",
                    "type": "Notification",
                    "data": {
                        "text": "",
                        "images": []
                    },
                    "customization": {},
                    "variantData": {
                        "isEditable": false,
                        "aspectRatio": "1/1",
                        "minImage": 4,
                        "maxImage": 12,
                        "modulo": 1,
                        "renderTabs": {
                            "product": null
                        }
                    },
                    "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/Notification_1.png",
                    "minMobileAppVersion": 1,
                    "isComingSoon": true
                }
            ]
        }
 export default Notification